import { render, staticRenderFns } from "./element.vue?vue&type=template&id=be42e35a&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=be42e35a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be42e35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be42e35a')) {
      api.createRecord('be42e35a', component.options)
    } else {
      api.reload('be42e35a', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=be42e35a&scoped=true&", function () {
      api.rerender('be42e35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_album/element.vue"
export default component.exports